import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseNestedFieldDefinition } from '../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../core/records/entities/partial-record.class';
import { ShIconModule } from '../../../elements/components/icon/icon.module';
import { ShFieldLabelComponent } from '../../../form-controls/components/_core/field-label/field-label.component';
import { ShComplexListReadonlyFieldComponent } from '../../../profile-form/components/readonly/complex-readonly-fields/complex-list-readonly-field/complex-list-readonly-field.component';
import { ComplexListFieldValue } from '../../../profile-form/entities/field-values/field-type-values.entity';
import { Face } from '../../entities/face.entity';
import { FaceInteractionService } from '../../services/face-interaction.service';
import { ShFaceTagComponent } from '../face-tag/face-tag.component';

@Component({
    standalone: true,
    selector: 'sh-faces-list-readonly-field',
    templateUrl: './faces-list-readonly-field.component.html',
    styleUrls: ['./faces-list-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShFieldLabelComponent, TranslateModule, RouterModule, ShFaceTagComponent, ShIconModule]
})
export class ShFacesListReadonlyFieldComponent extends ShComplexListReadonlyFieldComponent {
    private readonly faceInteractionService: FaceInteractionService = inject(FaceInteractionService);

    declare public faces: Face[];
    public personIdFieldDefinition: BaseNestedFieldDefinition | undefined;
    public personIdSearchable: boolean;

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const values: ComplexListFieldValue | null = this.fieldHelper.getComplexListFieldValue(
            profileField.FieldDefinition,
            record
        );

        const faceFieldDef = profileField.FieldDefinition.Children?.find(field => field.Key === 'Face');
        const personFieldDef = faceFieldDef?.Children?.find(field => field.Key === 'Person');
        this.personIdFieldDefinition = personFieldDef?.Children?.find(field => field.Key === 'RecordId');
        this.personIdSearchable = this.personIdFieldDefinition?.Searchable ?? false;

        if (values && Object.keys(values).length > 0) {
            this.faces = Object.values(values)[0] as unknown as Face[];
        } else {
            this.faces = [];
        }
    }

    // #region Interactions
    public focusFaceFrame(face: Face) {
        this.faceInteractionService.setFaceFrameFocus(face.Id);
    }

    public unfocusFaceFrame() {
        this.faceInteractionService.setFaceFrameFocus(null);
    }

    public hoverFaceFrame(face: Face) {
        this.faceInteractionService.setFaceFrameHover(face.Id);
    }

    public unhoverFaceFrame() {
        this.faceInteractionService.setFaceFrameHover(null);
    }
    // #endregion
}
